export default {
  home: {
    hero: {
      badge: 'Orchestration des livraisons par agents',
      title: 'Des agents IA qui gèrent vos livraisons,',
      titleEnd: 'selon vos règles.',
      description: 'Geofleet planifie les tournées, dispatche chaque commande, suit chaque arrêt en direct et capture la preuve de livraison. Les agents gèrent le travail routinier dans les limites que vous configurez, et votre équipe n’intervient que lorsque c’est utile.',
      feedTitle: 'Agents au travail',
      feedLive: 'En direct',
      feedFoot: 'Activité d’exemple · vos garde-fous',
      feedCta: 'Voir les agents',
      feed: [
        { text: 'L’agent de dispatch a affecté ODR-78262 à Amit Kumar', meta: 'Score 92 · 3,1 km · accepté en 6 s' },
        { text: 'Replanification de 4 arrêts autour d’une route fermée', meta: 'Hebbal · ETA maintenu dans le créneau' },
        { text: 'Le gardien SLA signale l’arrêt 12 à risque, 18 min de retard', meta: 'Réaffectation proposée pour approbation' },
        { text: 'Nouveaux ETA envoyés à 2 clients sur WhatsApp', meta: 'ODR-78251 · ODR-78264' },
        { text: 'Preuve de livraison capturée : photo, signature, OTP', meta: 'ODR-78240 · Priya Nair · 14:14' },
        { text: '3 règlements rapprochés, 1 signalé pour vérification', meta: 'Zone Nord · ₹1 850 en attente' },
      ],
      ctaPrimary: 'Commencer gratuitement',
      ctaSecondary: 'Réserver une démo',
      microTrust: 'Essai gratuit de 7 jours sur Lite · Plans dès 39 $/mois',
      countries: '20+ pays',
      customers: '100+ clients',
      orders: 'Plus d\'1M de commandes traitées',
      industriesHeading: 'Secteurs desservis',
      trustedBy: 'Des équipes opérations dans plus de 20 pays nous font confiance',
      imageAlt: 'Centre de commande Geofleet zone Nord : 96 % à l’heure, 24 chauffeurs actifs, carte en direct avec deux arrêts en retard, et Copilot proposant de déplacer les arrêts 12 et 14 vers un chauffeur proche avec de la capacité',
      phoneTrackingAlt: 'Page de suivi client personnalisée sur un téléphone avec carte en direct et détails du chauffeur',
      phoneDriverAlt: 'Écran d’accueil de l’app chauffeur Geofleet avec minuteur de service et tournée en cours',
      chipDelta: '+2 % vs hier', chipCopilot: 'Correctif proposé par Copilot', chipCopilotText: 'Réaffecter 2 arrêts en retard · ETA de retour dans le créneau',
      chipCustomer: 'Client informé', chipCustomerText: 'ETA en direct envoyé par SMS et WhatsApp',
      cityAlt: 'Vue aérienne d’une autoroute urbaine au coucher du soleil avec des camions et fourgons de livraison suivant des itinéraires bleus lumineux et des arrêts numérotés',
      statOnTimeLabel: 'Livraisons à l’heure',
      statOnTimeValue: '96 %',
      statCostLabel: 'Coût de livraison réduit',
      statCostValue: '20–30 %',
      statRiderLabel: 'Utilisation livreurs',
      statRiderValue: '+22 %',
      capRoute: 'Optimisation des tournées',
      capDispatch: 'Dispatch automatique',
      capTracking: 'Suivi en direct',
      capPod: 'Preuve de livraison',
      trustedLine: 'Plus de 100 équipes opérations dans plus de 20 pays nous font confiance',
      statSource: 'Résultats issus d’études de cas clients',
      announceBadge: 'Nouveau',
      announceText: 'Découvrez Geofleet Command : des agents IA configurés pour votre réseau',
      announceCta: 'Voir les plans',
      proofSecurity: 'Certifié SOC 2 et ISO 27001',
      costLine: 'de coûts de livraison en moins, selon nos études de cas clients',
      chooser: {
        subtitle: 'Choisissez l’option qui correspond à votre activité.',
        close: 'Fermer',
        title: 'D’où livrez-vous ?',
        liteTitle: 'Un hub, jusqu’à 25 chauffeurs',
        liteText: 'Geofleet Lite · essai gratuit de 7 jours, puis dès 39 $/mois',
        commandTitle: 'Plusieurs hubs ou plus de 25 chauffeurs',
        commandText: 'Geofleet Command · agents IA et workflows configurables, dès 19 $ par chauffeur',
      },
    },
    proofBar: {
      stats: [
        { value: '100+', label: 'Clients' },
        { value: '20+', label: 'Pays' },
        { value: '95 %', label: 'Taux de ponctualité' },
        { value: '99,99 %', label: 'Disponibilité' },
        { value: '50+', label: 'Intégrations' },
      ],
    },
    exceptionStory: {
      eyebrow: 'Centre de commande + Copilot',
      title: 'Un chauffeur en retard, géré automatiquement',
      subtitle: 'Geofleet repère le problème, prépare la solution et informe tout le monde. Votre équipe n’intervient que pour valider.',
      steps: [
        {
          title: 'Détecté automatiquement',
          body: 'Dès qu’un chauffeur prend du retard, Geofleet signale les arrêts à risque et les fait remonter en tête de file. Personne n’a besoin de les chercher.',
        },
        {
          title: 'Expliqué, pas seulement signalé',
          body: 'Copilot indique à l’équipe ce qui est en retard et pourquoi, par exemple des bouchons sur le périphérique. Chacun peut poser une question de suivi en langage courant.',
        },
        {
          title: 'Solution préparée pour vous',
          body: 'Il trouve le chauffeur le plus proche ayant de la capacité et prépare la réaffectation avec les nouvelles ETA, prête à valider en un clic ou appliquée automatiquement dans vos garde-fous.',
        },
        {
          title: 'Tout le monde informé automatiquement',
          body: 'Les apps des deux chauffeurs se mettent à jour, les clients reçoivent une nouvelle ETA par SMS ou WhatsApp et la modification est journalisée. Aucun appel, aucun message à envoyer.',
        },
      ],
      /** Labels on the screenshot for each step (sample data). */
      annotations: [
        { status: 'Risque détecté automatiquement', detail: 'Arrêt 12 · 18 min de retard' },
        { status: 'Synthèse de Copilot', detail: 'Cause : bouchons sur le périphérique' },
        { status: 'Solution prête à valider', detail: 'Transférer 2 arrêts à Amit Kumar' },
        { status: 'Traité automatiquement', detail: 'Clients notifiés par WhatsApp' },
      ],
      footnote: 'Choisissez ce qui s’exécute automatiquement et ce qui attend une validation. Chaque action est journalisée.',
      cta: 'Découvrir les agents IA',
      /** Caption under the step screenshots, which use illustrative data. */
      mock: { sample: 'Données d’exemple' },
    },
    platformCapabilities: {
      eyebrow: 'Plateforme',
      title: 'Les capacités d’une',
      titleHighlight: 'plateforme entreprise',
      subtitle: 'Geofleet planifie, dispatche, suit et prouve chaque livraison depuis une seule plateforme. Choisissez une capacité pour la voir dans le produit.',
      explore: 'Découvrir',
      prev: 'Capacité précédente',
      next: 'Capacité suivante',
      pause: 'Pause',
      play: 'Lecture',
    },
    industryImpact: {
      eyebrow: 'Témoignages clients',
      title: 'Un impact prouvé dans',
      titleHighlight: 'tous les grands secteurs',
      subtitle: 'Restaurants, épicerie, pharmacie, réseaux de colis et 3PL tournent sur Geofleet. Chaque histoire ci-dessous est un vrai client, anonymisé à sa demande.',
      challenge: 'Le défi',
      solution: 'La solution',
      readCaseStudy: 'Lire l’étude de cas',
      industryPage: 'Geofleet pour ce secteur',
      allCaseStudies: 'Voir toutes les études de cas',
    },
    whyGeofleet: {
      eyebrow: 'Pourquoi Geofleet',
      title: 'Pourquoi les équipes de livraison',
      titleHighlight: 'choisissent Geofleet',
      subtitle: 'Un centre de commande piloté par des agents, au-dessus des outils de preuve, de cash et de chauffeurs dont vous avez déjà besoin, avec les chiffres pour le prouver.',
      items: {
        dispatch: { title: 'Un dispatch qui tourne seul', body: 'Un agent toujours actif affecte chaque commande à un chauffeur ou transporteur en quelques secondes et la propose dans l’app chauffeur. Les dispatchers ne voient que les exceptions.' },
        onTime: { title: 'À l’heure, chaque jour', body: 'ETA en direct, réaffectation à chaque événement et alertes SLA gardent les tournées dans les temps quand la journée dérape.' },
        cost: { title: 'Un coût par livraison plus bas', body: 'Des tournées plus pleines, moins d’échecs et zéro dispatch manuel retirent 20 à 30 % du coût de chaque arrêt.' },
        reliability: { title: 'Conçu pour l’échelle et l’audit', body: 'SOC 2 et ISO 27001, 99,99 % de disponibilité et une trace de décision pour chaque affectation : les opérations et la finance peuvent se fier aux chiffres.' },
        integrations: { title: 'S’intègre à votre stack', body: 'Commandes depuis votre boutique ou ERP, mises à jour par WhatsApp et SMS, cash rapproché avec votre comptabilité. Sandbox, webhooks et API pour le reste.' },
        global: { title: 'Prêt pour chaque marché', body: 'Des équipes dans plus de 20 pays utilisent Geofleet avec le tableau de bord et l’app chauffeur en quatre langues et des prix affichés en devise locale.' },
      },
      labels: { order: 'Commande', matched: 'Affectée', accepted: 'Acceptée', onTimeRate: 'Taux de ponctualité', lowerCost: 'Coût par livraison en moins', manual: 'Manuel', uptime: 'Disponibilité', integrations: 'Intégrations', countries: 'Pays' },
    },
    integrationsHub: {
      eyebrow: 'Intégrations',
      title: 'Connecté en toute transparence avec',
      titleHighlight: 'plus de 50 intégrations natives',
      subtitle: 'Les commandes arrivent de votre boutique, POS ou ERP, les mises à jour partent vers les clients et le cash se rapproche avec votre comptabilité. Le Model Context Protocol permet à vos propres outils IA de travailler sur les mêmes données.',
      hubLabel: 'Centre de commande',
      categories: { commerce: 'Commerce & sources de commandes', erp: 'ERP, comptabilité & CRM', automation: 'Automatisation & IA', messaging: 'SMS & e-mail', payments: 'Paiements & alertes équipe', maps: 'Cartes & transporteurs' },
      soon: 'Bientôt disponible',
      cta: 'Voir toutes les intégrations',
      apiDocs: 'Documentation API',
    },
    lifecycle: {
      eyebrow: 'Comment ça marche',
      title: 'Six étapes de la commande à la preuve de livraison',
      cta: 'Voir comment ça marche',
      scrollHint: 'Faites défiler pour suivre une commande de l’import à la preuve de livraison.',
      /** Status pill and detail chip shown on the visual for each step (sample data). */
      annotations: [
        { status: 'Import des commandes', detail: '312 commandes · 3 à vérifier' },
        { status: 'Tournées optimisées', detail: '4 tournées · 312 arrêts planifiés' },
        { status: 'Dispatchée', detail: 'Tournée envoyée sur l’app d’Amit Kumar' },
        { status: 'En direct sur la carte', detail: 'Arrêt 12 réordonné · ETA 11:38 AM' },
        { status: 'Client notifié', detail: 'Lien de suivi envoyé par WhatsApp' },
        { status: 'Livrée', detail: 'Photo, signature et OTP enregistrés' },
      ],
      stepShort: ['Importer', 'Planifier', 'Dispatcher', 'Suivre', 'Notifier', 'Prouver'],
    },
    industryTabs: {
      eyebrow: 'Conçu pour votre secteur',
      title: 'Une plateforme, adaptée à votre façon de livrer',
      cta: 'Explorer {{industry}}',
      all: 'Tous les secteurs',
    },
    pricingTeaser: {
      eyebrow: 'Tarifs',
      title: 'Le prix est affiché sur la page',
      subtitle: 'Les deux démarrent à un prix mensuel avec chauffeurs et commandes inclus. Lite gère un hub avec un forfait fixe ; Command évolue par chauffeur sur plusieurs hubs.',
      perDriver: '/chauffeur/mois',
      compare: 'Comparer les plans',
      startFree: 'Commencer',
    },
    problemSection: {
      eyebrow: 'Réalité du dernier kilomètre',
      title: 'Le dispatch manuel casse l’efficacité du dernier kilomètre',
      subtitle:
        'Quand l’affectation vit dans les chats, appels et tableurs, ces effets sont inévitables—et s’amplifient à chaque pic.',
      pains: [
        {
          title: 'Livraisons retardées',
          description:
            'Les commandes attendent une décision humaine pendant que le trafic, la capacité et les SLA bougent—les retards s’accumulent et les clients partent.',
        },
        {
          title: 'Livreurs inactifs',
          description:
            'De la capacité reste inutilisée dans une zone alors que la demande explose ailleurs, faute de réaffectation assez rapide.',
        },
        {
          title: 'Surcharge des dispatchers',
          description:
            'Aux pics, l’équipe devient un standard manuel : triage, réassignations et corrections absorbent des heures qui devraient scaler.',
        },
        {
          title: 'ETA incohérentes',
          description:
            'Les créneaux promis dérivent si les plans ne sont pas calés sur la position en direct, la charge et l’état des tournées.',
        },
        {
          title: 'Inefficacité opérationnelle',
          description:
            'Le coût par arrêt augmente : kilomètres, heures sup et exceptions remplacent une exécution optimisée et répétable.',
        },
      ],
    },
    outcomes: {
      eyebrow: 'Résultats — pas une liste de fonctions',
      title: 'Ce qui change quand le dispatch tourne en temps réel',
      subtitle:
        'Les équipes adoptent Geofleet pour faire bouger les KPIs terrain : moins de retards, tournées plus pleines, dispatchers sur les exceptions—pas les tableurs.',
      items: [
        {
          headline: '30%',
          trend: 'down',
          title: 'Retards de livraison',
          sub: 'Moins d’incidents de retard vs affectation manuelle.',
        },
        {
          headline: '25%',
          trend: 'up',
          title: 'Utilisation des livreurs',
          sub: 'Plus d’arrêts productifs quand les commandes suivent la capacité en direct.',
        },
        {
          headline: '80%',
          trend: 'down',
          title: 'Effort manuel de dispatch',
          sub: 'Moins de réaffectations, d’appels et de corrections aux pics.',
        },
        {
          headline: 'À l’heure',
          trend: 'up',
          title: 'Taux de livraison',
          sub: 'Meilleur respect des SLA quand les ETA reflètent l’état des tournées.',
        },
      ],
    },
    roiCalculator: {
      eyebrow: 'Aperçu ROI',
      title: 'Estimez vos économies mensuelles',
      subtitle:
        'Modèle rapide à partir de votre volume, flotte et coût de retard—affinez avec nos équipes sur votre réseau réel.',
      ordersLabel: 'Commandes par jour',
      ridersLabel: 'Livreurs / chauffeurs',
      delayCostLabel: 'Coût moyen de retard par commande ($)',
      ordersHelp: 'Volume moyen quotidien que vous dispatcherez.',
      ridersHelp: 'Livreurs actifs sur le dernier kilomètre.',
      delayCostHelp: 'Coût moyen d’un retard ou d’une livraison sous-optimale (CX, nouvelle livraison, pénalités).',
      outputLabel: 'Économies mensuelles estimées',
      breakdownDelays: 'Moins de retards (30%)',
      breakdownUtil: 'Meilleure utilisation (25%)',
      breakdownManual: 'Moins de dispatch manuel (80% de l’effort type)',
      disclaimer:
        'Illustratif uniquement—pas un conseil financier ni une garantie. Résultats réels selon réseau, SLA et adoption. Réservez une démo pour un modèle sur mesure.',
      cta: 'Réserver une démo pour valider',
      ctaSecondary: 'Parler aux ventes',
    },
    aiAgents: {
      eyebrow: 'Agents IA pour la logistique',
      title: 'Ils dispatch, réacheminent et résolvent — avant que votre équipe n\'ait à le faire',
      intro:
        'Geofleet déploie des workflows agentiques dans votre tour de contrôle : transporteurs et chauffeurs sont appariés en temps réel, les tournées se replanifient quand le trafic ou le volume change, et le risque SLA remonte avec du contexte — pour que la croissance ne soit pas plafonnée par des playbooks manuels.',
      cta: 'Découvrir les agents IA',
    },
    trust: {
      title: 'Une tour de contrôle. Des agents IA pour le gros du travail.',
      subtitle: 'Automatisez les décisions qui brûlaient des heures de dispatch — sans tout remplacer dans votre stack.',
      benefits: [
        {
          title: 'Dispatch et affectation agentiques',
          description:
            'Les agents IA associent chaque envoi au bon transporteur et chauffeur selon capacité, coût, SLA, compétences et conditions live — en continu, pas en batch nocturne.',
        },
        {
          title: 'Des tournées qui se replanifient seules',
          description:
            'Quand le trafic bouge, qu\'une tentative échoue ou que des commandes arrivent en route, la planification agentique s\'adapte sans reconstruire les tours dans des tableurs.',
        },
        {
          title: 'Exceptions traitées dans la tour',
          description:
            'Alertes proactives sur risque SLA, retards et tensions de capacité — priorisées par l\'IA pour que l\'humain règle l\'essentiel pendant que les agents traitent le reste.',
        },
        {
          title: 'Une visibilité crédible pour la direction et les clients',
          description:
            'ETA prédictifs, suivi de marque et cartes live alimentés par le même modèle agentique que le dispatch — une seule version de la vérité.',
        },
      ],
    },
    howItWorks: {
      badge: 'Centre de commande',
      title: 'Une tour pour',
      titleHighlight: 'chatter et piloter',
      subtitle:
        'Tout se passe dans le centre de commande : discutez avec Copilot pour planifier et corriger, laissez-le exécuter des actions de masse, et finalisez le déploiement avec un onboarding assisté par l’IA—sans jongler entre outils.',
    },
    howItWorksBlocks: {
      pillarsSectionEyebrow: 'Fonctionnement',
      pillarsSectionTitle: 'Deux surfaces—pas une liste de fonctionnalités interminable',
      pillarsIntro:
        'Ci-dessous : Centre de commande (ops live) et Copilot (IA sur les mêmes données). Quatre capacités compactes chacun—facile à parcourir.',
      flowSectionTitle: 'Comment le parcours s’enchaîne',
      flowSectionIntro: 'Tour d’abord, puis Copilot, exécution et onboarding guidé—la même histoire, étape par étape.',
      steps: {
        commandCentre: 'Centre de commande',
        copilot: 'Copilot',
        execute: 'Exécuter et automatiser',
        aiOnboarding: 'Onboarding IA',
      },
      stepBlurbs: {
        commandCentre: 'Carte live, files et contrôles—une seule surface pour toute l’opération.',
        copilot: 'Demandez en langage naturel : tournées, exceptions, statuts.',
        execute: 'Transformez les réponses en mises à jour de masse, reroutages et workflows sans changer d’onglet.',
        aiOnboarding: 'Mise en route guidée : intégrations, hubs, rôles—Copilot accompagne vos équipes.',
      },
      majorFeatures: [
        {
          kicker: 'Opérations',
          title: 'Centre de commande',
          subtitle:
            'Une vue live de chaque commande, chauffeur et arrêt, avec les métriques et la piste d’audit derrière.',
          cards: [
            {
              title: 'Carte et files live',
              line: 'Livré, en transit et à risque ensemble—les exceptions remontent en haut.',
            },
            {
              title: 'Branchez votre stack',
              line:
                'Intégrations natives, MCP pour outils IA, CSV en masse ou saisie manuelle—chauffeurs, véhicules, hubs, commandes.',
            },
            {
              title: 'Planifiez et changez vite',
              line: 'Dispatch, réaffectation, mises à jour de masse et manifests selon votre politique.',
            },
            {
              title: 'Insights et audit',
              line: 'KPIs et drill-down sur les retards ; exports et historique pour CX, finance et conformité.',
            },
          ],
        },
        {
          kicker: 'Automatisation IA',
          title: 'Copilot et agents IA',
          subtitle:
            'Ils surveillent les opérations en direct, préparent les corrections et agissent dans vos garde-fous, pour que les incidents courants se règlent d’eux-mêmes.',
          cards: [
            {
              title: 'Détecter les problèmes tôt',
              line: 'Chauffeurs en retard, tentatives échouées et risques de SLA sont signalés dès qu’ils surviennent.',
            },
            {
              title: 'Préparer la correction',
              line: 'Réaffectations, reroutages et messages aux clients sont prêts à valider en un clic.',
            },
            {
              title: 'Agir dans vos garde-fous',
              line: 'Les actions courantes s’exécutent seules ; tout ce qui dépasse vos limites revient à une personne.',
            },
            {
              title: 'Expliquer à la demande',
              line: 'Demandez « qu’est-ce qui a changé depuis 09:00 ? » et obtenez des réponses tirées des données en direct, pas un texte d’IA générique.',
            },
          ],
        },
      ],
      seeInAction: 'Voir en action',
      howItWorksLink: 'Comment ça marche',
      bottomCtaTitle: 'Prêt à gérer vos livraisons à votre façon ?',
      bottomCtaSub: 'Une vue unique sur l\'expérience client et les opérations — sans tableurs.',
    },
    platformCarousel: {
      badge: 'Tour de contrôle',
      title: 'Découvrez Geofleet en action',
      subtitle: 'La même interface que vos agents : dispatch, carte live, tournées et analytics au même endroit.',
      slides: [
        { title: 'Tableau de dispatch', description: 'Un centre où agents et dispatchers assignent, rééquilibrent et traitent les exceptions en direct' },
        { title: 'Planification des tournées', description: 'Routage agentique qui réagit au trafic, aux créneaux et au volume — au-delà des fichiers de routes statiques' },
        { title: 'Suivi client', description: 'Suivi de marque avec ETA alimentées par le même modèle live que votre tour' },
        { title: 'Analytics et rapports', description: 'Voyez ce que agents et chauffeurs ont bougé — et où l\'automatisation a récupéré du temps et de la marge' },
      ],
    },
    transformation: {
      badge: 'Transformation',
      title: 'Ce que Geofleet fait pour vos',
      titleHighlight: 'opérations logistiques',
      subtitle: 'Des processus manuels et fragmentés à une tour de contrôle pilotée par l\'IA — découvrez le changement.',
      withoutGeofleet: 'Sans Geofleet',
      withGeofleet: 'Avec Geofleet',
      controlTower: 'Tour de contrôle pilotée par l\'IA',
      exploreFeatures: 'Découvrir les fonctionnalités',
      beforeItems: [
        'Heures passées en dispatch manuel et planification des tournées',
        'Aucune visibilité en temps réel — clients et ops dans le flou',
        'Tableurs et outils multiples qui ne communiquent pas',
        'Retards, preuves de livraison manquantes et litiges',
        'Pertes de revenus (COD, remboursements, inefficacité)',
      ],
      afterItems: [
        'Les agents IA dispatch et optimisent les tournées en quelques secondes',
        'Suivi en direct, ETAs et pages de suivi à votre marque',
        'Une tour de contrôle pour flotte, commandes et analytics',
        'ePOD, e-signature, OTP — moins de litiges, preuves conformes',
        'Récupérez du chiffre, réduisez les coûts et scalez sereinement',
      ],
      joinTeams: 'Rejoignez les équipes qui ont fait le pas',
      stat1: '20–30 % de réduction des coûts',
      stat2: '95 % de livraisons à l\'heure',
      stat3: 'Zéro dispatch manuel',
    },
    scaleImpact: {
      title: 'Les opérations flotte tournent sur',
      titleBrand: 'Geofleet',
      subtitle: 'Du single-hub aux flottes multi-pays — agents IA et humains dans une tour dernier kilomètre.',
      stats: [
        { label: 'Taux de livraison à l\'heure' },
        { label: 'Réduction des coûts' },
        { label: 'Efficacité chauffeur' },
        { label: 'Opérations pilotées par l\'IA' },
      ],
      multiRegion: 'Multi-région',
      enterpriseReady: 'Prêt pour l\'entreprise',
      integrations: '50+ intégrations',
    },
    trustedLeaders: {
      badge: 'Approuvé par les leaders du secteur',
      title: 'Les équipes entreprise font tourner',
      titleBrand: 'Geofleet',
      subtitle: 'Des scale-ups aux logistiques Fortune 500 — les entreprises qui traitent des millions de livraisons font confiance à Geofleet pour piloter leurs opérations.',
      testimonials: [
        { quote: "Le dispatch IA de Geofleet a éliminé la majeure partie de notre planification manuelle. Nous avons scalé les livraisons de prescriptions quotidiennes sans ajouter de dispatchers — conformité et livraison à l'heure ont progressé partout.", author: 'Responsable opérations', role: 'Pharmacie', company: 'Qatar', metric: 'Livraisons scalées' },
        { quote: "Le moteur d'ETA prédictif a réduit nettement les appels de réclamations. Nos clients entreprise nous considèrent désormais comme meilleurs en livraison dernier kilomètre dans la région.", author: 'Responsable logistique', role: 'Entreprise de logistique', company: 'EAU', metric: '70 % de réclamations en moins' },
        { quote: "Nous avons intégré Geofleet à nos équipes terrain en quelques semaines. La plateforme gère le dispatch, la visibilité chauffeurs et la preuve de livraison pour que nous puissions nous concentrer sur la disponibilité et la sécurité.", author: 'Responsable flotte', role: 'Entreprise d\'énergie renouvelable', company: 'Inde', metric: 'Déploiement plus rapide' },
      ],
      stats: [
        { value: '100+', label: 'Clients' },
        { value: '1M+', label: 'Livraisons traitées' },
        { value: '20+', label: 'Pays' },
        { value: '99,99 %', label: 'Disponibilité plateforme' },
        { value: '24/7', label: 'Support entreprise' },
      ],
      badges: [
        { label: 'Conforme SOC 2' },
        { label: 'Conforme GDPR' },
        { label: 'SLA 99,99 %' },
        { label: 'SSO' },
        { label: 'API-First' },
      ],
    },
    driverExperience: {
      badge: 'Expérience chauffeur',
      title: 'Une app chauffeur qu\'ils vont',
      titleHighlight: 'vraiment adorer',
      subtitle: 'Conçue pour la rapidité et la simplicité. Tout ce dont un chauffeur a besoin pour livrer plus vite — rien de plus.',
      features: [
        { title: 'Tournées optimisées par l\'IA', description: 'Navigation guidée avec contournements trafic en temps réel. Les chauffeurs prennent toujours le chemin le plus rapide.', stat: '30 % plus rapide' },
        { title: 'Preuve de livraison intelligente', description: 'Photos vérifiées par l\'IA, e-signatures et confirmation OTP — le tout en un tap.', stat: 'POD en 1 tap' },
        { title: 'File de tâches intelligente', description: 'L\'IA ordonne les stops par priorité, créneaux et proximité. Plus de guesswork, plus de SLA manqués.', stat: '95 % à l\'heure' },
        { title: 'Communication in-app', description: 'Appels en un tap, numéros masqués et chat dispatch — sans quitter l\'app.', stat: 'Zéro friction' },
        { title: 'Scan code-barres et ID', description: 'Scannez les codes des colis et vérifiez l\'ID client pour livraisons restreintes ou haute valeur.', stat: '100 % vérifié' },
        { title: 'Prêt hors ligne', description: 'Toutes les fonctions en zone blanche. Les données se synchronisent au retour de la connexion.', stat: 'Toujours actif' },
      ],
      delivered: 'Livré',
      orderId: '#1246',
      rating: 'Note',
      ratingValue: '4.9/5',
      availableOn: 'Disponible sur iOS et Android',
      downloadOnThe: 'Télécharger sur',
      appStore: 'App Store',
      getItOn: 'Disponible sur',
      googlePlay: 'Google Play',
      appStoreRating: '4.9 sur l\'App Store',
    },
    coreFeatures: {
      badge: 'IA + plateforme',
      title: 'Découvrez Geofleet en action',
      subtitle: 'Dispatch, routage agentique, suivi et analytics — tout ce dont vos agents et équipes ont besoin dans une stack.',
      platformLine: 'Profondeur produit et visibilité entreprise — agents et humains sur les mêmes données live.',
      carousel: {
        dispatch: 'Dispatch',
        routes: 'Tournées',
        tracking: 'Suivi',
        analytics: 'Analytics',
        dispatchHeadline: 'Un hub pour chaque commande et chaque chauffeur',
        dispatchDescription: 'Gérez le dispatch depuis un seul écran — assignez les chauffeurs, mettez à jour le statut et gérez les exceptions en temps réel. Fini les tableurs et les commandes oubliées.',
        routesHeadline: 'Tournées optimisées par l\'IA en quelques secondes',
        routesDescription: 'Notre moteur prend en compte le trafic, les créneaux et la capacité pour réduire les kilomètres et le carburant. Plus d\'étapes par tournée avec moins de planification.',
        trackingHeadline: 'Suivi à votre marque, carte en direct et ETA',
        trackingDescription: 'Offrez à chaque client une page de suivi avec votre logo et une carte en direct. Moins d\'appels « où est ma commande ? » et plus de retours positifs.',
        analyticsHeadline: 'Des indicateurs qui améliorent les performances',
        analyticsDescription: 'Délais de livraison, taux de ponctualité, fiches chauffeurs et coût par livraison — le tout dans des tableaux de bord pour progresser chaque semaine.',
      },
      learnMore: 'En savoir plus',
      whatIncluded: 'Ce qui est inclus',
      stats: { eta: 'Précision ETA', savings: 'Économies tournées', disputes: 'Moins de litiges' },
      ctaDemo: 'Réserver une démo',
      ctaTrial: 'Commencer',
      pillarsCrossLink:
        'Le centre de commande et Copilot sont détaillés dans « Fonctionnement » ci-dessus — ce carrousel parcourt les quatre écrans produit clés.',
      pillarsCrossLinkCta: 'Aller à Fonctionnement',
    },
    integrations: {
      label: 'Intégrations',
      title: 'Model Context Protocol pour votre stack livraison',
      paragraph:
        'Geofleet prend en charge MCP pour que assistants et agents travaillent avec un contexte structuré et autorisé sur vos opérations, avec des connecteurs natifs pour plus de 10 SMS, plus de 10 emails, plus de 10 passerelles de paiement, plus de 5 000 appareils IoT et plus de 10 OMS comme Shopify et Unicommerce. Un protocole pour l’IA ; couverture complète SMS, email, paiements, IoT et commandes.',
      learnMore: 'En savoir plus',
      footerLine: 'MCP · SMS · Email · WhatsApp · Line · Paiements · OMS · IoT · POS · Livraison',
    },
    demoCta: {
      title: 'Mettez des agents IA au service de votre logistique',
      subtitle: 'Plus de 100 entreprises pilotent dispatch, tournées et exceptions depuis une tour Geofleet',
      ctaTrial: 'Commencer',
      ctaDemo: 'Réserver une démo',
      noCard: 'Lite dès 49 $/mois, essai gratuit de 7 jours',
      freeTrial: 'Command dès 190 $/mois pour 10 chauffeurs',
      cancelAnytime: 'Annulez à tout moment',
    },
    faq: {
      supportLabel: 'Support',
      title: 'Questions fréquentes',
      subtitle: 'Réponses rapides sur Geofleet et comment démarrer.',
      items: [
        { question: 'Qu\'est-ce que Geofleet ?', answer: 'Geofleet est une plateforme livraisons et flotte avec des agents IA dans la tour de contrôle. Elle automatise l\'affectation transporteurs et chauffeurs, la planification agentique des tournées, les alertes SLA et les flux d\'exception — avec suivi temps réel, ETA prédictifs, ePOD et analytics sur hubs, chauffeurs et intégrations.' },
        { question: 'Comment démarrer ?', answer: 'Si vous livrez depuis un seul hub, commencez avec Geofleet Lite dès 49 $ par mois avec 3 chauffeurs et 500 commandes, et un essai gratuit de 7 jours. Lite Plus (99 $) ajoute les tournées, l’attribution automatique, WhatsApp et l’API, et Lite Autopilot (179 $) ajoute AI Copilot et Autopilot. Les équipes multi-hubs commencent sur Geofleet Command dès 190 $ par mois pour 10 chauffeurs.' },
        { question: 'Geofleet fonctionne-t-il avec mes outils actuels ?', answer: 'Oui. Geofleet s\'intègre avec plus de 10 fournisseurs SMS, plus de 10 fournisseurs d\'email, plus de 10 passerelles de paiement, plus de 5 000 appareils IoT et plus de 10 OMS comme Shopify et Unicommerce, ainsi que POS et partenaires de livraison. Nous proposons aussi une API et des webhooks pour des intégrations sur mesure.' },
        { question: 'Combien coûte Geofleet ?', answer: 'Geofleet Lite commence à 49 $ par mois avec 3 chauffeurs et 500 commandes depuis un hub ; Lite Plus coûte 99 $ et Lite Autopilot 179 $. Geofleet Command commence à 190 $ par mois pour 10 chauffeurs et 5 000 commandes sur Professional, soit 19 $ par chauffeur ; Premium AI coûte 29 $ par chauffeur. Enterprise est sur devis.' },
        { question: 'Prenez-vous en charge plusieurs sites et hubs ?', answer: 'Oui. Geofleet est conçu pour les opérations multi-hubs et multi-régions. Vous pouvez gérer plusieurs entrepôts, dark kitchens ou magasins depuis un seul tableau de bord, avec accès par rôles, analytics par hub et dispatch IA qui prend en compte tous les sites.' },
        { question: 'Quel type de support offrez-vous ?', answer: 'Nous fournissons un support email, une aide in-app et une documentation pour tous les plans. Les offres supérieures incluent un support prioritaire et des success managers dédiés. Vous pouvez aussi réserver une démo ou parler aux ventes pour des besoins sur mesure.' },
      ],
    },
  },
};
